/**
 * RTWO Cryptography & Identity Engine — Service Registry
 */

import type { ICryptoService, ICryptoServiceRegistry } from '../service-interfaces';

export class CryptoServiceRegistry implements ICryptoServiceRegistry {
  private readonly services = new Map<string, ICryptoService>();

  register(service: ICryptoService): void {
    this.services.set(service.serviceId, service);
  }

  get<T extends ICryptoService>(serviceId: string): T | null {
    return (this.services.get(serviceId) as T) ?? null;
  }

  getAll(): ICryptoService[] {
    return Array.from(this.services.values());
  }

  has(serviceId: string): boolean {
    return this.services.has(serviceId);
  }

  count(): number {
    return this.services.size;
  }
}
